export const messages = {
  en: {
    componentConditionManage: {
      condition: 'Condition',
      conditionId: 'Condition ID',
      name: 'Name',
      holdpace: 'Placeholder',
      param: 'Parameter',
      type: 'Type',
      seq: 'Sequence',
      remark: 'Description',
      operation: 'Operation',
      text: 'Text',
      date: 'Date',
      addCondition: 'Add Condition',
      editCondition: 'Edit Condition',
      confirmDeleteCondition: 'Are you sure to delete this condition?',
      namePlaceholder: 'Required, please enter name',
      holdpacePlaceholder: 'Required, please enter placeholder',
      paramPlaceholder: 'Required, please enter parameter',
      typePlaceholder: 'Required, please select type',
      seqPlaceholder: 'Required, please enter sequence',
      remarkPlaceholder: 'Optional, please enter description',
      nameRequired: 'Name is required',
      nameMaxLength: 'Name cannot exceed 64 characters',
      holdpaceRequired: 'Placeholder is required',
      holdpaceMaxLength: 'Placeholder cannot exceed 64 characters',
      paramRequired: 'Parameter is required',
      paramMaxLength: 'Parameter cannot exceed 64 characters',
      typeRequired: 'Type is required',
      seqRequired: 'Sequence is required',
      seqNumber: 'Sequence must be a number',
      conditionIdRequired: 'Condition ID is required'
    }
  },
  zh: {
    componentConditionManage: {
      condition: '条件',
      conditionId: '条件ID',
      name: '名称',
      holdpace: '提示',
      param: '参数',
      type: '类型',
      seq: '序号',
      remark: '描述',
      operation: '操作',
      text: '文本框',
      date: '日期',
      addCondition: '添加条件',
      editCondition: '修改条件',
      confirmDeleteCondition: '确定删除该条件吗？',
      namePlaceholder: '必填，请填写名称',
      holdpacePlaceholder: '必填，请填写提示',
      paramPlaceholder: '必填，请填写参数',
      typePlaceholder: '必填，请选择类型',
      seqPlaceholder: '必填，请填写序号',
      remarkPlaceholder: '选填，请填写描述',
      nameRequired: '名称不能为空',
      nameMaxLength: '名称不能超过64个字符',
      holdpaceRequired: '提示不能为空',
      holdpaceMaxLength: '提示不能超过64个字符',
      paramRequired: '参数不能为空',
      paramMaxLength: '参数不能超过64个字符',
      typeRequired: '类型不能为空',
      seqRequired: '序号不能为空',
      seqNumber: '序号必须是数字',
      conditionIdRequired: '条件ID不能为空'
    }
  }
}